(function () {
  var MOBILE_BREAKPOINT = 767;
  var STORAGE_KEY = 'innan-dynamic-spacer';

  function parsePx(value) {
    if (typeof value === 'number' && !isNaN(value)) return value;
    if (typeof value === 'string') {
      var num = parseFloat(value);
      return isNaN(num) ? 0 : num;
    }
    return 0;
  }

  function getGapPx(container) {
    var style = window.getComputedStyle(container);
    var gap = style.gap || style.rowGap || '0';
    var parts = gap.trim().split(/\s+/);
    return parsePx(parts[0] || 0);
  }

  function getHeaderHeightPx() {
    var headerEl = document.getElementById('header-component');
    var announcementEl = document.getElementById('announcement-bar');
    var headerH = headerEl && headerEl.offsetHeight ? headerEl.offsetHeight : 0;
    var announcementH = announcementEl && announcementEl.offsetHeight ? announcementEl.offsetHeight : 0;
    return headerH + announcementH + 24;
  }

  function isMobile() {
    return typeof window !== 'undefined' && window.innerWidth <= MOBILE_BREAKPOINT;
  }

  function readCachedHeight() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      var vh = window.innerHeight;
      var hh = getHeaderHeightPx();
      if (data.vh === vh && data.hh === hh && typeof data.height === 'number') {
        return data.height;
      }
    } catch (e) { 
      console.error('Failed to read cached height:', e);
    }
    return null;
  }

  function writeCachedHeight(height) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        vh: window.innerHeight,
        hh: getHeaderHeightPx(),
        height: height
      }));
    } catch (e) {
      console.error('Failed to write cached height:', e);
    }
  }

  function setSpacerCollapsed(spacer) {
    spacer.style.position = 'absolute';
    spacer.style.left = '-9999px';
    spacer.style.width = '0';
    spacer.style.height = '0';
    spacer.style.overflow = 'hidden';
  }

  function setSpacerVisible(spacer, heightPx) {
    spacer.style.position = '';
    spacer.style.left = '';
    spacer.style.width = '';
    spacer.style.overflow = '';
    spacer.style.display = 'block';
    spacer.style.height = heightPx - 20 + 'px';
  }

  function getMeasuredElements(spacer) {
    var container = spacer.parentElement;
    if (!container || !container.classList.contains('group-block-content')) return null;
    if (!spacer.closest('.product-details')) return null;
    var buyButtons = container.querySelector('.buy-buttons-block');
    var groupBlock = spacer.previousElementSibling;
    while (groupBlock && groupBlock.classList && groupBlock.classList.contains('view-product-title')) {
      groupBlock = groupBlock.previousElementSibling;
    }
    if (!groupBlock || !buyButtons) return null;
    var variantPicker = container.querySelector('variant-picker');
    return { container: container, groupBlock: groupBlock, variantPicker: variantPicker, buyButtons: buyButtons };
  }

  function updateHeight(spacer) {
    if (isMobile()) {
      setSpacerCollapsed(spacer);
      return;
    }

    var measured = getMeasuredElements(spacer);
    if (!measured) return;

    var container = measured.container;
    var groupBlock = measured.groupBlock;
    var variantPicker = measured.variantPicker;
    var buyButtons = measured.buyButtons;

    var headerHeightPx = getHeaderHeightPx();
    var availableHeight = window.innerHeight - headerHeightPx;
    var gapPx = getGapPx(container);
    var gapsTotal = 3 * gapPx;
    var groupHeight = groupBlock.offsetHeight;
    var variantPickerHeight = variantPicker ? variantPicker.offsetHeight : 0;
    var buyButtonsHeight = buyButtons.offsetHeight;

    var spacerHeight = availableHeight - groupHeight - variantPickerHeight - buyButtonsHeight - gapsTotal;
    var height = Math.round(spacerHeight);

    if (height <= 0) {
      setSpacerCollapsed(spacer);
      writeCachedHeight(0);
      return;
    }

    setSpacerVisible(spacer, height);
    writeCachedHeight(height);
  }

  function runUpdate(spacer) {
    requestAnimationFrame(function () {
      updateHeight(spacer);
    });
  }

  function getSpacerForNotifyWrapper(wrapper) {
    var productDetails = wrapper && wrapper.closest && wrapper.closest('.product-details');
    return productDetails ? productDetails.querySelector('dynamic-spacer') : null;
  }

  function getSpacerForResizeTarget(target) {
    if (target.tagName && target.tagName.toLowerCase() === 'dynamic-spacer') return target;
    if (target.getAttribute && target.getAttribute('data-notify-form-wrapper') !== null) {
      return getSpacerForNotifyWrapper(target);
    }
    var container = target.closest && target.closest('.group-block-content');
    return container ? container.querySelector('dynamic-spacer') : null;
  }

  var resizeObserver = new ResizeObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      var spacer = getSpacerForResizeTarget(entries[i].target);
      if (spacer) runUpdate(spacer);
    }
  });

  var DynamicSpacer = function () {
    var self = Reflect.construct(HTMLElement, [], DynamicSpacer);
    return self;
  };
  DynamicSpacer.prototype = Object.create(HTMLElement.prototype);
  DynamicSpacer.prototype.constructor = DynamicSpacer;
  DynamicSpacer.prototype.connectedCallback = function () {
    var spacer = this;
    spacer.style.flexShrink = '0';
    spacer.style.minHeight = '0';
    spacer.style.boxSizing = 'border-box';

    if (isMobile()) {
      setSpacerCollapsed(spacer);
      runUpdate(spacer);
    } else {
      var cached = readCachedHeight();
      if (cached !== null) {
        if (cached > 0) {
          setSpacerVisible(spacer, cached);
        } else {
          setSpacerCollapsed(spacer);
        }
      } else {
        spacer.style.display = 'block';
      }
      runUpdate(spacer);
    }

    resizeObserver.observe(spacer);
    if (spacer.parentElement) {
      resizeObserver.observe(spacer.parentElement);
    }
    var measured = getMeasuredElements(spacer);
    if (measured) {
      var toObserve = [measured.groupBlock, measured.buyButtons];
      if (measured.variantPicker) toObserve.push(measured.variantPicker);
      this._observedMeasured = toObserve;
      for (var j = 0; j < toObserve.length; j++) {
        resizeObserver.observe(toObserve[j]);
      }
      var notifyWrapper = measured.container.querySelector('.buy-buttons-block [data-notify-form-wrapper]');
      if (notifyWrapper) {
        this._notifyWrapper = notifyWrapper;
        resizeObserver.observe(notifyWrapper);
      }
    }

    this._boundResize = function () {
      runUpdate(spacer);
    };
    window.addEventListener('resize', this._boundResize);
  };
  DynamicSpacer.prototype.disconnectedCallback = function () {
    resizeObserver.unobserve(this);
    if (this.parentElement) {
      resizeObserver.unobserve(this.parentElement);
    }
    if (this._observedMeasured) {
      for (var i = 0; i < this._observedMeasured.length; i++) {
        resizeObserver.unobserve(this._observedMeasured[i]);
      }
      this._observedMeasured = null;
    }
    if (this._notifyWrapper) {
      resizeObserver.unobserve(this._notifyWrapper);
      this._notifyWrapper = null;
    }
    window.removeEventListener('resize', this._boundResize);
  };

  customElements.define('dynamic-spacer', DynamicSpacer);
})();
